export const EVENT_CLASS_LABELS = {
  VISIT: "visit",
  SIGNUP: "signup",
  LOGIN: "login",
  USAGE: "usage",
} as const;

export type EventClassValue = keyof typeof EVENT_CLASS_LABELS;

export const LOGIN_TYPE_LABELS = {
  WORK_SSO: "Work SSO",
  WORK_EMAIL: "Work email",
  PERSONAL_EMAIL: "Personal email",
  SHARED: "Shared",
  UNKNOWN: "Unknown",
} as const;

export type LoginTypeValue = keyof typeof LOGIN_TYPE_LABELS;

export const formatEventClassLabel = (
  eventClass?: string | null,
): string | undefined => {
  if (!eventClass) {
    return undefined;
  }
  return EVENT_CLASS_LABELS[eventClass as EventClassValue] ?? eventClass.toLowerCase();
};

export const formatLoginTypeLabel = (
  loginType?: string | null,
): string | undefined => {
  if (!loginType) {
    return undefined;
  }
  return LOGIN_TYPE_LABELS[loginType as LoginTypeValue];
};
